import Vue from 'vue';
import App from './App.vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const options = {
    buttonsStyling: false,
    confirmButtonClass: 'btn btn-primary',
    cancelButtonClass: 'btn btn-light',
};

Vue.use(VueSweetalert2, options);

import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents)

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
}).$mount('#app')

// Check that service workers are supported
function invokeServiceWorkerUpdateFlow(registration) {
    Vue.swal({
        title: 'Ladda om appen!',
        text: 'En ny version av appen finns tillgänglig.',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Avbryt',
        confirmButtonText: 'OK, ladda om',
        confirmButtonClass: 'btn btn-success'
    }).then((result) => {
        if (result.isConfirmed) {
            if (registration.waiting) {
                // let waiting Service Worker know it should became actived
                registration.waiting.postMessage({ type: 'SKIP_WAITING'});
            }
        }
    });
}

// check if the browser supports serviceWorker at all
if ('serviceWorker' in navigator) {
    // wait for the page to load
    window.addEventListener('load', async () => {
        // register the service worker from the file specified
        const registration = await navigator.serviceWorker.register('/service-worker.js');

        // ensure the case when the updatefound event was missed is also handled
        // by re-invoking the prompt when there's a waiting Service Worker
        if (registration.waiting) {
            invokeServiceWorkerUpdateFlow(registration);
        }

        // detect Service Worker update available and wait for it to become installed
        registration.addEventListener('updatefound', () => {
            if (registration.installing) {
                // wait until the new Service worker is actually installed (ready to take over)
                registration.installing.addEventListener('statechange', () => {
                    if (registration.waiting) {
                        // if there's an existing controller (previous Service Worker), show the prompt
                        if (navigator.serviceWorker.controller) {
                            invokeServiceWorkerUpdateFlow(registration);
                        } else {
                            // otherwise it's the first install, nothing to do
                            console.log('Service Worker initialized for the first time');
                        }
                    }
                })
            }
        })

        let refreshing = false;

        // detect controller change and refresh the page
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (!refreshing) {
                window.location.reload();
                refreshing = true;
            }
        })
    })
}
